export default __webpack_public_path__ + "static/media/profile2.435afa0e.jpeg";